<mat-error *ngIf="errorFormList && errorFormList.length > 0" class="wrapper">
  <div class="col">
    <strong>Bitte beheben Sie folgende Fehler im Formular</strong>

    <div *ngFor="let error of errorFormList; let itemIndex = index; first as isFirst; last as isLast">
      <li style="padding-left: 1rem" *ngIf="(!isFirst && showAll) || isFirst">
        {{ error.displayName }} {{ error.errorMessage }} {{ error.comment }}
      </li>
      <div *ngIf="isLast && errorFormList.length > 1">
        <button mat-button color="warn" (click)="clickToogleShowMoreErrors()">
          <span *ngIf="!showAll">
            <mat-icon style="padding-right: 4px">visibility</mat-icon>
            weitere Fehler anzeigen
          </span>
          <span *ngIf="showAll">
            <mat-icon style="padding-right: 4px">visibility_off</mat-icon>
          </span>
        </button>
      </div>
    </div>
  </div>
</mat-error>
